import { render, staticRenderFns } from "./PurchaseReturnReview.vue?vue&type=template&id=cc3e7c52"
import script from "./PurchaseReturnReview.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports